import React from "react";

interface SectionHeaderProps {
  sectionName: string;
  isExpanded: boolean;
  onToggle: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  sectionName,
  isExpanded,
  onToggle,
}) => {
  return (
    <h2 className="sdk-test-section-header" onClick={onToggle}>
      <span>{sectionName}</span>
      <span className="sdk-test-section-chevron">
        {isExpanded ? "▼" : "▶"}
      </span>
    </h2>
  );
};

